import fetchRamsSignings from '../Services/fetchRamsSignings'

export default () => (dispatch) => {

  dispatch(fetchRamsSignings())

}
